<template>
    <div class="home">
        <b-container>
            <div class="d-none d-xl-block d-lg-block d-xl-none">
                <b-col cols="12">
                    <router-link to="/">
                        <img src="@/assets/img/locomash_logo_main.svg" class="locomash-logo" />
                    </router-link>
                </b-col>
            </div>
            <div class="d-xl-none d-lg-none">
                <b-col cols="12">
                    <router-link to="/">
                        <img
                            src="@/assets/img/locomash_logo_main.svg"
                            class="locomash-logo"
                            style="width: 75%;"
                        />
                    </router-link>
                </b-col>
            </div>
            <b-row>
                <b-col cols="12">
                    <a href="https://www.instagram.com/locomash/">
                        <b-img
                            :src="require('@/assets/img/ICO_IG.jpg')"
                            class="locomash-social pulse"
                        ></b-img>
                    </a>
                    <a href="https://twitter.com/locomash">
                        <b-img
                            :src="require('@/assets/img/ICO_TW.jpg')"
                            class="locomash-social pulse"
                        ></b-img>
                    </a>
                    <a href="mailto:mash@locomash.net">
                        <b-img
                            :src="require('@/assets/img/ICO_MAIL.jpg')"
                            class="locomash-social pulse"
                        ></b-img>
                    </a>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" cols="12" class="locomash-book-tile pulse">
                    <router-link to="/random">
                        <b-img :src="require('@/assets/book_random.jpg')" fluid></b-img>
                    </router-link>
                </b-col>
                <b-col lg="4" cols="12" class="locomash-book-tile pulse">
                    <router-link to="/otros">
                        <b-img :src="require('@/assets/book_otros.jpg')" fluid></b-img>
                    </router-link>
                </b-col>
                <b-col lg="4" cols="12" class="locomash-book-tile pulse">
                    <router-link to="/spark">
                        <b-img :src="require('@/assets/book_spark.jpg')" fluid></b-img>
                    </router-link>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="4" cols="12" offset-lg="4" class="locomash-book-tile pulse">
                    <router-link to="/freelance">
                        <b-img :src="require('@/assets/book_freelance.jpg')" fluid></b-img>
                    </router-link>
                </b-col>
            </b-row>
        </b-container>
        <footer>
            <p>LOCOMASH &copy; {{ yearDate() }} | Developed by BlueBaloon Inc.</p>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'home',
    methods: {
        yearDate() {
            return new Date().getFullYear()
        },
    },
}
</script>
<style>
@-webkit-keyframes pulse {
    /* 25% {
        -webkit-transform: scale(1.2);
        transform: scale(1.2);
    }
    75% {
        -webkit-transform: scale(0.8);
        transform: scale(0.8);
    } */
    0% {
        display: none;
        opacity: 0.2;
    }

    25% {
        display: block;
        opacity: 0.6;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

@keyframes pulse {
    /* 25% {
        -webkit-transform: scale(1.2);
        -ms-transform: scale(1.2);
        transform: scale(1.2);
    }
    75% {
        -webkit-transform: scale(0.8);
        -ms-transform: scale(0.8);
        transform: scale(0.8);
    } */
    0% {
        display: none;
        opacity: 0.2;
    }

    25% {
        display: block;
        opacity: 0.6;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

.pulse {
    display: inline-block;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}

.pulse:hover {
    -webkit-animation-name: pulse;
    animation-name: pulse;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
}
.brightness {
    background-color: white;
    display: inline-block;
    color: black;
    text-decoration: none;
    filter: alpha(opacity=0);
}
.brightness:hover {
    top: 0px; /* adjust as needed */
    left: -25px;
    opacity: 1;
    filter: alpha(
        opacity=100
    ); /*position where      
    enlarged image should offset horizontally */
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}
</style>
